var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "29F1BFA4-011E-4293-BC6B-7B00A76D02B1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jenna-web-interface-user-empty",
    transform: "translate(-235.000000, -17.000000)",
    fill: "#3778F0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(235.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9451714,1.05489844 C16.2649327,0.374625 15.3605378,0 14.3985568,0 C13.4365759,0 12.6802386,0.319761719 12,1 L2,11 C1.91435933,11.0856406 1.63915207,11.3119102 1.60666768,11.4285937 L0.0257606456,17.108332 C-0.0424073568,17.3533008 0.0269559587,17.6160234 0.207272454,17.7953555 C0.34086627,17.9282461 0.519881984,18 0.703186762,18 C0.767241481,18 0.8318587,17.9912109 0.89524545,17.9732109 L6.57498654,16.3598555 C6.81461166,16.291793 6.93714059,16.2410664 7,16 C7.06285941,15.7589336 7.05669772,15.3635273 6.88081091,15.1870781 L3.30007476,11.5954805 L12,3 L15,6 L8.35902648,12.7247344 C8.08406932,12.9989531 8.08347166,13.4441367 8.35769055,13.7190937 C8.63187428,13.9940859 9.0771284,13.9946484 9.35205041,13.7204648 L16.9451714,6 C17.6254451,5.31976172 18,4.56345703 18,3.60147656 C18,2.63949609 17.6253748,1.73510156 16.9451714,1.05489844 Z M5.04122406,15.3336797 L1.71656617,16.2780469 L2.64767991,12.9328594 L5.04122406,15.3336797 Z M15.9514443,5.15302734 L15.7417372,5.36217188 L12.6375794,2.25798047 L12.8463373,2.04922266 C13.2609352,1.63458984 13.8121854,1.40625 14.3985568,1.40625 C14.9849282,1.40625 15.5361433,1.63458984 15.9507763,2.04925781 C16.3654093,2.46385547 16.5937493,3.01510547 16.5937493,3.60147656 C16.5937493,4.18784766 16.3654093,4.73909766 15.9514443,5.15302734 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5f07820ddaae77bae75752700b7fc619.svg";
export { ForwardRef as ReactComponent };